<virtual-scroller
  #scroller
  [parentScroll]="parentScrollElement"
  [items]="renderedIds"
  [enableUnequalChildrenSizes]="true"
  [bufferAmount]="virtualScrollBuffer"
  [scrollThrottlingTime]="50"
>
  <div #container class="items-container">
    @for (itemId of scroller.viewPortItems; track trackBy(i, itemId); let i = $index) {
      @if (getRenderedItemById(itemId); as item) {
        <app-virtual-scroll-item
          [id]="itemId"
          [item]="item"
          [itemTemplate]="itemTemplate"
          [itemContext]="
            createItemTemplateContext(
              item,
              i,
              i === 0 ? undefined : getRenderedItemById(scroller.viewPortItems[i - 1]),
              scroller.viewPortItems[i + 1] ? getRenderedItemById(scroller.viewPortItems[i + 1]) : undefined
            )
          "
          (sizeChange)="scroller.invalidateCachedMeasurementForItem(getRenderedItemById(itemId))"
        ></app-virtual-scroll-item>
      }
    }
  </div>
</virtual-scroller>
